import type { DailyV2TimelineEvent } from '@/api/schema/daily'
import { dayjs } from '@/api/utils/dayjs'
import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useNavigate } from '@/app/hooks/useNavigate'
import ChevronRight from '@/app/icons/chevron-right.svg?react'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

function formatTimelineDate(date: string) {
  const value = dayjs(date)
  const tomorrow = dayjs().add(1, 'day')

  if (value.isSame(tomorrow, 'day')) {
    return 'Завтра'
  }

  return value.format('D MMMM')
}

export const TimelineItem: FunctionalComponent<{
  item: DailyV2TimelineEvent
}> = props => {
  const route = useNavigate()

  return (
    <UI.Panel
      clickable
      type='ghost'
      class={styles.item}
      onClick={() => {
        const q = `${dayjs(props.item.date).format('D MMMM')}, ${props.item.event}, что меня ждёт?`
        route(`~/chats/zoe?q=${encodeURIComponent(q)}`)
      }}
    >
      <Col alignItems='center'>
        <Row gap={5} flexGrow={1}>
          <Text fontWeight={600} fontSize={16}>
            {formatTimelineDate(props.item.date)}
          </Text>
          <Text fontSize={14} opacity={0.5}>
            {props.item.event}
          </Text>
        </Row>

        <ChevronRight
          width={20}
          height={20}
          strokeWidth={1.5}
          class={styles.chevron}
        />
      </Col>
    </UI.Panel>
  )
}
